export default __webpack_public_path__ + "static/media/marketplace.c02030a7.png";